import Breadcrumb from "@/components/base/Breadcrumb";
import { usePageMeta } from "@/hooks/usePageMeta";
import FeedbackForm from "@/pages/contact/components/FeedbackForm";

const contacts = [
  {
    icon: "ri-mail-line",
    label: "客服邮箱",
    value: "service@guochanjiujiu.com",
    desc: "内容纠错与合作事宜",
  },
  {
    icon: "ri-phone-line",
    label: "客服电话",
    value: "400-800-1234",
    desc: "工作日 09:00 - 18:00",
  },
  {
    icon: "ri-map-pin-line",
    label: "办公地址",
    value: "北京市朝阳区影视文化产业园",
    desc: "来访请提前预约",
  },
];

export default function Contact() {
  usePageMeta(
    "联系反馈 - 国产久久久",
    "通过联系反馈页面与国产久久久取得联系，查看客服邮箱、客服电话并提交您的意见与建议。",
    "联系反馈,国产久久久,客服,意见反馈"
  );

  return (
    <div className="w-full">
      <div className="bg-background-100 border-b border-background-200">
        <div className="w-full px-4 md:px-8 py-6 md:py-8">
          <Breadcrumb items={[{ label: "首页", path: "/" }, { label: "联系反馈" }]} />
          <h1 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            联系反馈
          </h1>
          <p className="mt-2 text-sm text-foreground-600 max-w-2xl leading-relaxed">
            如果您对本站内容有任何意见或建议，欢迎随时与我们联系，我们会认真阅读每一条反馈。
          </p>
        </div>
      </div>

      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
          <aside className="w-full lg:w-80 shrink-0 flex flex-col gap-4">
            {contacts.map((item) => (
              <div
                key={item.label}
                className="rounded-lg bg-background-50 border border-background-200 p-5"
              >
                <div className="flex items-center gap-3">
                  <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-50 text-primary-600 shrink-0">
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <div className="min-w-0">
                    <p className="text-xs text-foreground-500">{item.label}</p>
                    <p className="text-sm font-medium text-foreground-950 break-words">
                      {item.value}
                    </p>
                  </div>
                </div>
                <p className="mt-3 text-xs text-foreground-500">{item.desc}</p>
              </div>
            ))}

            <div className="rounded-lg bg-secondary-100 border border-secondary-200 p-5">
              <h2 className="font-heading text-sm font-semibold text-secondary-900">
                反馈小提示
              </h2>
              <ul className="mt-3 flex flex-col gap-2 text-xs text-secondary-800 leading-relaxed">
                <li>· 内容纠错请注明影片名称或资讯标题</li>
                <li>· 合作事宜请留下联系方式与合作说明</li>
                <li>· 我们通常在 1-3 个工作日内回复</li>
              </ul>
            </div>
          </aside>

          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-1 h-5 rounded-full bg-primary-500"></span>
              <h2 className="font-heading text-xl font-semibold text-foreground-950">
                在线反馈
              </h2>
            </div>
            <FeedbackForm />
          </div>
        </div>
      </div>
    </div>
  );
}